import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "../api/axios";
import { Link } from "react-router-dom";

function SearchResults() {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const q = queryParams.get("q")?.toLowerCase() || "";
  const cat = queryParams.get("cat")?.toLowerCase() || "";

  const [allProducts, setAllProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    // Get all products from API
    const fetchProducts = async () => {
      try {
        const response = await axios.get("/products");
        setAllProducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);
  useEffect(() => {
    // Get all products from API
    const fetchCategories = async () => {
      try {
        const response = await axios.get("/categories");
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);
  

  useEffect(() => {
    // Filter products in frontend only
    let results = allProducts;
    console.log("Filtering products:", { q, cat });
    if (q) {
      results = results.filter((p) =>
        p.name.toLowerCase().includes(q)
      );
    }
    

    if (cat && cat !== "all categories") {
      results = results.filter(
  (p) => String(p.category_id) === String(cat)
);

    }

    setFilteredProducts(results);
  }, [q, cat, allProducts]);

  return (
    <div className="container mt-5">
      <h2>
        Search Results for "<strong>{q}</strong>"
        {cat === "all categories" ? (
          <span>
            {" "}in <strong>{cat}</strong>
          </span>
        ) : (
          <span>
            {" "}in <strong>{categories.find((c) => c.id == cat)?.name || cat}</strong>
           
          </span>
        )}
      </h2>

      {loading ? (
        <p>Loading results...</p>
      ) : filteredProducts.length > 0 ? (
        <div className="row mt-4">
          {filteredProducts.map((product) => (
            <div key={product.id} className="col-md-3 mb-4">
              <div className="card h-100">
                <Link to={`/product/${product.id}`}>
                  <img
                    src={product.image_url}
                    alt={product.name}
                    className="card-img-top"
                    style={{ objectFit: "cover", height: "200px" }}
                  />
                </Link>
                <div className="card-body">
                  <h5 className="card-title">{product.name}</h5>
                  <p className="card-text">${product.price}</p>
                  <Link
                    to={`/product/${product.id}`}
                    className="btn btn-primary btn-sm"
                  >
                    View
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="mt-4">No products found.</p>
      )}
    </div>
  );
}

export default SearchResults;
